export const PREBILL_ITEM_TYPE = {
  LABOR: "Labor",
  MATERIAL: "Material",
  WARRANTY: "Warranty",
  DISCOUNT: "Discount",
};

export const PREBILL_PAYMENT_METHOD = {
  PURCHASE_ORDER: "PurchaseOrder",
  CREDIT_CARD: "CreditCard",
  CHECK: "Check",
  CASH: "Cash",
};

export const PREBILL_PAYMENT_METHOD_LABEL_MAP = {
  [PREBILL_PAYMENT_METHOD.PURCHASE_ORDER]: "Purchase Order",
  [PREBILL_PAYMENT_METHOD.CREDIT_CARD]: "Credit Card",
  [PREBILL_PAYMENT_METHOD.CHECK]: "Check",
  [PREBILL_PAYMENT_METHOD.CASH]: "Cash",
};

export const PREBILL_UNCATEGORIZED_TYPE = "Uncategorized";

export const DISCOUNT_TYPE = {
  PERCENTAGE: "Percentage",
  AMOUNT: "Amount",
};

export const PREBILL_ITEM_TYPE_OPTIONS = Object.values(PREBILL_ITEM_TYPE).map(
  (x) => ({ label: x, value: x })
);

export const PREBILL_PAYMENT_NUMBER_LABEL_MAP = {
  [PREBILL_PAYMENT_METHOD.PURCHASE_ORDER]: "Purchase Order #",
  [PREBILL_PAYMENT_METHOD.CREDIT_CARD]: "Confirmation #",
  [PREBILL_PAYMENT_METHOD.CHECK]: "Check #",
  [PREBILL_PAYMENT_METHOD.CASH]: "Receipt #",
};

export const PREBILL_PAYMENT_METHOD_OPTIONS = Object.values(
  PREBILL_PAYMENT_METHOD
).map((x) => ({ label: PREBILL_PAYMENT_METHOD_LABEL_MAP[x], value: x }));

export const PREBILL_ITEM_ORDER_MAP = {
  [PREBILL_ITEM_TYPE.LABOR]: 0,
  [PREBILL_ITEM_TYPE.MATERIAL]: 1,
  [PREBILL_ITEM_TYPE.WARRANTY]: 2,
  [PREBILL_ITEM_TYPE.DISCOUNT]: 3,
  [PREBILL_UNCATEGORIZED_TYPE]: 4,
};
